import { baseUseClinicianListQueryKey } from 'vl-common/src/components/BookAppointment/useClinicianList';
import { baseGetSlotBucketsQueryKey } from '@vl-core/getSlotBuckets';

export const appointmentBookedQueriesToInvalidate = [
  baseUseClinicianListQueryKey,
  baseGetSlotBucketsQueryKey,
  ['userAppointment'],
  ['get-direct-book-referrals'],
  ['get-active-cases'],
  ['useUserNextAppointments'],
  ['clinicianAppointment'],
  ['timeline'],
  ['getUserAppointment'],
  ['userCalendarEvents'],
  ['getNextSteps'],
  ['todoList']
] as const;
